import $ from "jquery";
import Rails from "rails-ujs";
import "jquery-ui/ui/widgets/sortable";
import "init";

window.jQuery = $;
Rails.start();

$(function () {
  // YP subscribe: show email form on button click
  $(".yp-subscribe-btn").on("click", function () {
    var block = $(this).closest(".yp-subscribe-block");
    $(this).hide();
    block.find(".yp-email-form").removeClass("hidden");
    block.find("input[name=email]").focus();
  });

  // YP subscribe: check email and redirect
  $(".yp-email-form form").on("submit", function (e) {
    e.preventDefault();
    var form = $(this);
    var email = form.find("input[name=email]").val();
    var checkUrl = form.data("check-url");
    var checkoutUrl = form.data("checkout-url");
    var msg = form.siblings(".yp-email-message");

    $.post(checkUrl, { email: email }, function (data) {
      if (data.exists) {
        msg.removeClass("hidden").text(
          "Такой мейл уже есть, отправим тебя логинится через 5,4,3,2,1"
        );
        var count = 5;
        var interval = setInterval(function () {
          count--;
          msg.text(
            "Такой мейл уже есть, отправим тебя логинится через " + count
          );
          if (count <= 0) {
            clearInterval(interval);
            window.location.href = "/login";
          }
        }, 1000);
      } else {
        var url = checkoutUrl + "?email=" + encodeURIComponent(email);
        var utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
        var currentParams = new URLSearchParams(window.location.search);
        utmKeys.forEach(function (key) {
          if (currentParams.has(key)) {
            url += "&" + key + "=" + encodeURIComponent(currentParams.get(key));
          }
        });
        window.location.href = url;
      }
    });
  });

  // Общие опции всех sortable-списков админки (фикс drag-drop, S2 п.2).
  // Почему именно так:
  //   cancel — внутри хэндла-строки живут ссылки/кнопки/формы/summary: клик по ним НЕ должен
  //            стартовать перетаскивание (иначе «Открыть урок» превращается в drag).
  //   tolerance: "pointer" — срабатывание по курсору, а не по пересечению площадей: при
  //            неравных высотах элементов "intersect" требовал протащить полкарточки.
  //   forcePlaceholderSize — плейсхолдер держит высоту, список не «схлопывается» под курсором.
  //   scrollSensitivity/scrollSpeed — вменяемый автоскролл на длинных списках (дефолт 20 px/тик).
  var LMS_SORTABLE_OPTS = {
    items: "> li",
    axis: "y",
    cancel: "a, button, input, select, textarea, summary, form",
    tolerance: "pointer",
    forcePlaceholderSize: true,
    scrollSensitivity: 60,
    scrollSpeed: 30,
  };

  // LMS-админка N10: реордер верхнеуровневых узлов потока (streams/show) — плоский
  // одноуровневый список. Отдельный класс js-stream-lessons-sortable + хэндл
  // js-stream-lesson-handle (теперь это ВСЯ строка-заголовок узла, а не глиф ⠿ в 11×24 px),
  // БЕЗ connectWith и БЕЗ вложенных списков того же класса → всплытие sortupdate между
  // инстансами невозможно. .fail делает провал сохранения видимым.
  $(".js-stream-lessons-sortable").sortable($.extend({}, LMS_SORTABLE_OPTS, {
    handle: ".js-stream-lesson-handle",
    update: function () {
      var $ul = $(this);
      var ids = $ul
        .children("li")
        .map(function () {
          return $(this).data("stream-lesson-id");
        })
        .get();
      $.ajax({
        url: $ul.data("reorder-url"),
        method: "PATCH",
        data: { ordered_ids: ids },
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        },
      }).fail(function () {
        alert("Не удалось сохранить порядок узлов. Обновите страницу.");
      });
    },
  }));

  // LMS-редактор урока N10: реордер прямых детей узла — плоский одноуровневый список.
  // Отдельный класс js-lesson-edges-sortable + хэндл js-edge-handle (≠ узлового), БЕЗ
  // connectWith → список изолирован, читает только свои > li. Рекурсивный под-DAG на
  // streams/show НЕ sortable (display + button_to) → баг вложенных sortable исключён.
  $(".js-lesson-edges-sortable").sortable($.extend({}, LMS_SORTABLE_OPTS, {
    handle: ".js-edge-handle",
    update: function () {
      var $ul = $(this);
      var ids = $ul
        .children("li")
        .map(function () {
          return $(this).data("lesson-edge-id");
        })
        .get();
      $.ajax({
        url: $ul.data("reorder-url"),
        method: "PATCH",
        data: { ordered_ids: ids },
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        },
      }).fail(function () {
        alert("Не удалось сохранить порядок подуроков. Обновите страницу.");
      });
    },
  }));

  // LMS-редактор урока: перетаскивание порядка видео внутри одного урока.
  // Один список на урок (без connectWith — порядок только внутри урока).
  // .fail добавлен: раньше провал сохранения был тихим — порядок «менялся» лишь на экране.
  $(".js-video-list").sortable($.extend({}, LMS_SORTABLE_OPTS, {
    handle: ".js-drag-handle",
    update: function () {
      var $ul = $(this);
      var ids = $ul
        .children("li")
        .map(function () {
          return $(this).data("material-video-id");
        })
        .get();
      $.ajax({
        url: $ul.data("reorder-url"),
        method: "PATCH",
        data: { ordered_ids: ids },
        headers: {
          "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        },
      }).fail(function () {
        alert("Не удалось сохранить порядок видео. Обновите страницу.");
      });
    },
  }));

  // ── Markdown-компонент (S3, п.13): ОДНО поле, два режима в ОДНОЙ зоне ──
  // Было side-by-side (textarea + вечно висящая панель превью) — на узком экране редактор
  // терял половину ширины. Стало: «Редактирование» (по умолчанию) ⇄ «Предпросмотр» —
  // кнопками .js-md-mode или хоткеем ⌘/Ctrl+E. Рендер — тем же серверным MarkdownRenderer
  // (POST на data-preview-url), поэтому «превью == финальный рендер».
  // Обработка по .js-md-field, а не по одиночному селектору: полей на странице может быть
  // несколько (блок 04 — тема + тело письма).
  var MD_ACTIVE_CLASSES = "bg-gray-900 text-white";
  var MD_IDLE_CLASSES = "bg-white text-gray-600 hover:bg-gray-100";

  function setMarkdownMode($field, mode) {
    var $editor = $field.find(".js-md-editor");
    var $preview = $field.find(".js-md-preview");

    $field.find(".js-md-mode").each(function () {
      var isActive = $(this).data("mode") === mode;
      $(this)
        .toggleClass(MD_ACTIVE_CLASSES, isActive)
        .toggleClass(MD_IDLE_CLASSES, !isActive);
    });
    $field.data("md-mode", mode);

    if (mode === "edit") {
      $preview.addClass("hidden");
      $editor.removeClass("hidden");
      return;
    }

    // Предпросмотр: запрашиваем HTML у сервера и показываем его ВМЕСТО textarea (та же зона).
    $.ajax({
      url: $field.data("preview-url"),
      method: "POST",
      data: { body: $editor.val() },
      headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") },
    })
      .done(function (html) {
        $preview.html(html);
      })
      .fail(function () {
        // Не оставляем панель с устаревшим содержимым молча — показываем ошибку предпросмотра.
        $preview.html(
          '<p class="text-red-600 text-sm">Не удалось обновить предпросмотр. Проверьте соединение и попробуйте ещё раз.</p>'
        );
      });
    $editor.addClass("hidden");
    $preview.removeClass("hidden");
  }

  $(".js-md-field").each(function () {
    setMarkdownMode($(this), "edit"); // режим по умолчанию — редактирование
  });

  $(document).on("click", ".js-md-mode", function () {
    setMarkdownMode($(this).closest(".js-md-field"), $(this).data("mode"));
  });

  // ⌘E (mac) / Ctrl+E (win) — тоггл режима. Цель: поле, в котором сейчас фокус; если фокуса
  // в md-поле нет — первое поле на странице.
  $(document).on("keydown", function (e) {
    if (!(e.metaKey || e.ctrlKey) || String(e.key).toLowerCase() !== "e") return;

    var $field = $(document.activeElement).closest(".js-md-field");
    if (!$field.length) $field = $(".js-md-field").first();
    if (!$field.length) return;

    e.preventDefault();
    setMarkdownMode($field, $field.data("md-mode") === "preview" ? "edit" : "preview");
  });

  // ── localStorage-черновик формы (S3, п.5) ──
  // Пишем значения полей на каждый ввод, восстанавливаем после перезагрузки без сохранения.
  // Чистим ТОЛЬКО по серверному маркеру .js-draft-clear (его рендерит shared/_draft_clear при
  // flash[:lms_draft_saved], т.е. после успешных create/update). При 422 и 409 (конфликт
  // optimistic lock) маркера нет → черновик остаётся, текст админа не теряется.
  // Не сохраняем: файлы (в localStorage их не положить), скрытые поля, CSRF-токен и _method —
  // они приходят с сервера и подстановка устаревшего значения только навредит.
  var DRAFT_SKIP =
    "input[type=file], input[type=hidden], input[name=authenticity_token], input[name=_method], button, [type=submit]";

  function draftFields($form) {
    return $form.find("input, textarea, select").not(DRAFT_SKIP);
  }

  // Снимок формы. Радио/чекбоксы кладём по ЗНАЧЕНИЮ отмеченного элемента: наивное
  // data[name] = $(el).val() записало бы value последнего радио группы, а на восстановлении
  // .val(x) переписало бы у радио сам атрибут value — форма отправила бы мусор.
  function draftSnapshot($form) {
    var data = {};
    draftFields($form).each(function () {
      if (!this.name) return;
      if (this.type === "radio" || this.type === "checkbox") {
        if (this.checked) data[this.name] = this.value;
        return;
      }
      data[this.name] = $(this).val();
    });
    return data;
  }

  // Серверный маркер «сохранено» → чистим перечисленные ключи (у формы создания и у редактора
  // записи ключи разные: create пишет под …:new, а редирект ведёт уже на …:<id>).
  // ВАЖНО: очистка обязана идти ДО восстановления ниже. Иначе на странице после успешного
  // сохранения черновик сперва подставлялся в форму (и показывал плашку «восстановлен»), и лишь
  // потом удалялся из localStorage: запись черновика дебаунсится на 300 мс, поэтому при быстром
  // сабмите в ключе лежит УСЕЧЁННЫЙ текст, который перетирал актуальные серверные значения.
  $(".js-draft-clear").each(function () {
    var keys = String($(this).data("draft-keys") || "").split(",");
    keys.forEach(function (key) {
      if (key) localStorage.removeItem(key);
    });
  });

  $(".js-draft-form").each(function () {
    var $form = $(this);
    var key = $form.data("draft-key");
    if (!key) return;

    // Восстановление: подставляем только те поля, что реально есть в форме сейчас.
    // Плашку показываем, лишь если черновик ОТЛИЧАЕТСЯ от того, что отрисовал сервер —
    // иначе она врала бы на каждом открытии редактора.
    var stored = localStorage.getItem(key);
    if (stored) {
      var data = JSON.parse(stored);
      var restored = false;
      draftFields($form).each(function () {
        var name = this.name;
        if (!name || !Object.prototype.hasOwnProperty.call(data, name)) return;

        if (this.type === "radio" || this.type === "checkbox") {
          var shouldCheck = String(this.value) === String(data[name]);
          if (this.checked !== shouldCheck) {
            this.checked = shouldCheck;
            restored = true;
          }
          return;
        }
        if ($(this).val() !== data[name]) {
          $(this).val(data[name]);
          restored = true;
        }
      });
      if (restored) $form.find(".js-draft-restored").removeClass("hidden");
    }

    // Запись с дебаунсом 300 мс — делегированно, чтобы ловить и динамически добавленные поля.
    var draftTimer;
    $form.on("input change", "input, textarea, select", function () {
      clearTimeout(draftTimer);
      draftTimer = setTimeout(function () {
        localStorage.setItem(key, JSON.stringify(draftSnapshot($form)));
      }, 300);
    });

    // «Отбросить» — гасим черновик и перезагружаем страницу серверными значениями.
    $form.find(".js-draft-discard").on("click", function () {
      localStorage.removeItem(key);
      window.location.reload();
    });
  });

  // ── File-инпут: имя выбранного файла (S7, п.8) ──
  // Нативный input[type=file] показывает имя только внутри своей кнопки, а с file:-стилями
  // (wrapper :tailwind_file) админ вообще не видел, что именно выбрал. Дорисовываем сами:
  // делегированно — поля могут добавляться динамически.
  $(document).on("change", ".js-file-field input[type=file]", function () {
    var files = this.files;
    var text = "Файл не выбран";
    if (files && files.length === 1) text = files[0].name;
    else if (files && files.length > 1) text = "Выбрано файлов: " + files.length;

    $(this).closest(".js-file-field").find(".js-file-name").text(text);
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // LMS: плеер видео — seek по таймкодам у ВСЕХ провайдеров (S4, п.1) + детекция
  // «видео не загрузилось» (п.7).
  //
  // Было сломано: ветки seek существовали только для youtube/vimeo (cloudflare и kinescope —
  // молчаливый no-op), команда слалась ОДИН раз в момент клика, без знания о готовности плеера,
  // да ещё и по iframe с loading="lazy" (contentWindow = about:blank). Теперь — реестр адаптеров
  // + ready-gate (load у iframe / ready-сигнал провайдера) + очередь отложенного seek + ретраи.
  //
  // S3 (04): ретраи слались ВСЛЕПУЮ (postToFrame размножал ЛЮБОЕ сообщение по SEEK_RETRIES) —
  // готовый плеер получал 3 команды seek (а YouTube-адаптер зовёт postToFrame дважды → до 6
  // сообщений) и перематывал 2–3 раза. Готовность расщеплена на ДВЕ оси:
  //   PLAYER_LOADED   — iframe отдал `load` (есть транспорт; гасит таймер «Видео недоступно»);
  //   PLAYER_API_READY — API провайдера подтвердило, что слушает команды (CF iframeReady,
  //                      YouTube onReady, Vimeo ready) — ТОЛЬКО на этом гейтится seek.
  //
  // ИНВАРИАНТ: один клик = РОВНО ОДНА доставка. Единственная точка доставки — deliverSeek: он
  // атомарно снимает токен PENDING_SEEK, поэтому повторный сигнал (ready после слепой попытки,
  // второй ready, «догоняющий» таймер) перемотку НЕ дублирует. Слепых ретраев seek больше НЕТ:
  // виджет провайдера начинает принимать postMessage РАНЬШЕ, чем отдаёт ready (документ в iframe
  // живёт до события `load`), поэтому слепая попытка могла быть ИСПОЛНЕНА, а пришедший следом
  // ready доставлял тот же клик второй раз — «догоняющий прыжок» (ревью S3, находка №1). Клик до
  // готовности API просто ждёт ready-сигнала; если тот не приходит вовсе — срабатывает последний
  // рубеж (armLastResortSeek), доставляющий клик ОДИН раз через тот же deliverSeek.
  // ─────────────────────────────────────────────────────────────────────────────
  var PLAYER_LOADED = {}; // playerId → true: iframe отдал load (транспорт есть)
  var PLAYER_API_READY = {}; // playerId → true: API провайдера подтвердило готовность принимать команды
  var PENDING_SEEK = {}; // playerId → секунды: клик, ЕЩЁ НЕ доставленный плееру (он же токен «не доставлено»)
  var SEEK_TIMERS = {}; // playerId → [timeoutId]: отложенные эффекты ОДНОГО клика (отменяемы)
  var CF_READY = {}; // playerId → true: Cloudflare-плеер прислал iframeReady
  var CF_FALLBACK_ARMED = {}; // playerId → true: перезагрузка с ?startTime= уже запланирована (не дублируем)
  var LOAD_TIMERS = {}; // playerId → таймер детекции «не загрузилось»
  var KINESCOPE_PLAYERS = {}; // playerId → Promise<player> официального Iframe Player API
  var KINESCOPE_LOADER = null; // Promise ленивой загрузки SDK Kinescope
  var SEEK_LAST_RESORT_MS = 1200; // транспорт есть, ready так и не пришёл → доставить ОДИН раз вслепую
  var HANDSHAKE_RETRIES = [0, 400, 1200]; // listening-хендшейк YouTube: не seek, повтор идемпотентен
  var CF_FALLBACK_MS = 1500; // нет iframeReady → перезагрузка iframe с ?startTime=
  var VIDEO_LOAD_TIMEOUT_MS = 12000; // iframe не отдал load → показать блок ошибки

  // Origin провайдера из самого src — единственный корректный targetOrigin (для подписанного
  // Cloudflare это customer-<code>.cloudflarestream.com, для youtube-nocookie — его домен).
  function frameOrigin(iframe) {
    var match = String(iframe.getAttribute("src") || "").match(/^(https?:\/\/[^/]+)/i);
    return match ? match[1] : "*";
  }

  // Команда провайдеру — РОВНО ОДНО сообщение. Ретраи живут уровнем выше (SEEK_TIMERS), где их
  // можно отменить по ready-сигналу: слепое размножение здесь и давало 2–3 перемотки на клик.
  function postToFrame(iframe, message) {
    if (!iframe.contentWindow) return;
    iframe.contentWindow.postMessage(message, frameOrigin(iframe));
  }

  // Отложенный эффект ОДНОГО клика: таймер регистрируется, чтобы ready-сигнал или следующий клик
  // могли его снять (иначе «догоняющие» прыжки к предыдущему таймкоду).
  function scheduleSeekTimer(playerId, delay, fn) {
    if (!SEEK_TIMERS[playerId]) SEEK_TIMERS[playerId] = [];
    SEEK_TIMERS[playerId].push(setTimeout(fn, delay));
  }

  function clearSeekTimers(playerId) {
    (SEEK_TIMERS[playerId] || []).forEach(clearTimeout);
    delete SEEK_TIMERS[playerId];
    delete CF_FALLBACK_ARMED[playerId];
  }

  // Cloudflare Stream: протокол Stream Player SDK без подключения самого SDK. Родитель шлёт
  // ОБЪЕКТ (не JSON-строку) setProperty currentTime; iframe отвечает iframeReady (см. слушатель
  // message ниже). ⚠️ __privateUnstable* — приватный контракт CF: если он поменяется, сработает
  // страховка — перезагрузка iframe с ДОКУМЕНТИРОВАННЫМ embed-параметром ?startTime=<sec>s.
  // Фолбэк-перезагрузка src регистрируется в SEEK_TIMERS: пришедший iframeReady или новый клик
  // обязаны её снять, иначе iframe перезагрузится УЖЕ ПОСЛЕ успешной перемотки — глазами
  // пользователя это второй seek.
  function cloudflareSeek(iframe, seconds, playerId) {
    postToFrame(iframe, {
      __privateUnstableMessageType: "setProperty",
      property: "currentTime",
      value: seconds,
    });
    armCloudflareFallback(iframe, seconds, playerId);
  }

  // Страховка на случай, если iframeReady не придёт ВОВСЕ (приватный контракт CF уплыл): через
  // CF_FALLBACK_MS перезагружаем iframe с документированным ?startTime=. Взводится один раз на
  // клик (CF_FALLBACK_ARMED) и снимается пришедшим iframeReady или следующим кликом
  // (clearSeekTimers). Отделена от cloudflareSeek: в окне «клик до готовности API» страховку надо
  // взвести, НЕ отправляя при этом сам setProperty (иначе плеер может исполнить команду, а
  // следом за ней ещё раз — по ready-сигналу).
  function armCloudflareFallback(iframe, seconds, playerId) {
    if (CF_READY[playerId] || CF_FALLBACK_ARMED[playerId]) return;
    CF_FALLBACK_ARMED[playerId] = true;
    scheduleSeekTimer(playerId, CF_FALLBACK_MS, function () {
      delete CF_FALLBACK_ARMED[playerId];
      if (CF_READY[playerId]) return;
      // Перезагрузка с ?startTime= И ЕСТЬ доставка seek — снимаем токен «не доставлено».
      delete PENDING_SEEK[playerId];
      iframe.setAttribute("src", withStartTime(iframe.getAttribute("src"), seconds));
    });
  }

  // ?startTime=30s&autoplay=true поверх текущего src (путь с signed-токеном сохраняется).
  function withStartTime(src, seconds) {
    var base = String(src).split("#")[0].split("?");
    var params = (base[1] || "").split("&").filter(function (p) {
      return p && p.indexOf("startTime=") !== 0 && p.indexOf("autoplay=") !== 0;
    });
    params.push("startTime=" + Math.floor(seconds) + "s", "autoplay=true");
    return base[0] + "?" + params.join("&");
  }

  // Kinescope — ЕДИНСТВЕННОЕ исключение из «никаких внешних ресурсов» (CLAUDE.md): сырой
  // postMessage у них требует хендшейка @_IFRAME_PING/@_IFRAME_HOST_READY с генерацией uid и
  // конвертами callMethod — переизобретать приватный протокол нельзя. Официальный Iframe Player
  // API грузим ЛЕНИВО и ТОЛЬКО если на странице есть kinescope-видео. Сбой загрузки скрипта =
  // seek no-op, страница жива.
  function loadKinescopeSdk() {
    if (KINESCOPE_LOADER) return KINESCOPE_LOADER;
    KINESCOPE_LOADER = new Promise(function (resolve) {
      var script = document.createElement("script");
      script.src = "https://player.kinescope.io/latest/iframe.player.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });
    return KINESCOPE_LOADER;
  }

  // Плеер создаём поверх УЖЕ отрендеренного сервером <iframe> (SDK переиспользует переданный
  // элемент, свой не создаёт) → разметка и CSP-поверхность не меняются. Промис кэшируем.
  function kinescopePlayer(iframe, playerId) {
    if (KINESCOPE_PLAYERS[playerId]) return KINESCOPE_PLAYERS[playerId];
    KINESCOPE_PLAYERS[playerId] = loadKinescopeSdk()
      .then(function () {
        if (!window.Kinescope || !window.Kinescope.IframePlayer) return null;
        return window.Kinescope.IframePlayer.create(iframe, {
          url: iframe.getAttribute("src"),
        });
      })
      .catch(function () {
        return null; // best-effort: провайдер недоступен → seek не работает, страница цела
      });
    return KINESCOPE_PLAYERS[playerId];
  }

  // Плеер не поднялся (скрипт SDK недоступен) ИЛИ контракт seekTo уплыл при обновлении SDK.
  // Документированного embed-параметра со стартовым временем у Kinescope нет (в отличие от
  // ?startTime= у Cloudflare), поэтому фолбэк «перезагрузить src» невозможен — вместо молчаливого
  // no-op честно говорим пользователю, что перемотка не сработала (S4, п.1: клик по таймкоду
  // никогда не должен «проваливаться» без обратной связи).
  function kinescopeSeek(iframe, seconds, playerId) {
    kinescopePlayer(iframe, playerId).then(function (player) {
      if (player && typeof player.seekTo === "function") {
        player.seekTo(seconds);
        return;
      }
      showSeekUnavailable(iframe);
    });
  }

  // Реестр адаптеров: data-player-kind → как перемотать. Неизвестный провайдер (kind="iframe")
  // адаптера не имеет — API у него нет, остаётся только прокрутка к плееру (не падаем).
  var SEEK_ADAPTERS = {
    youtube: function (iframe, seconds) {
      postToFrame(iframe, JSON.stringify({ event: "command", func: "seekTo", args: [seconds, true] }));
      postToFrame(iframe, JSON.stringify({ event: "command", func: "playVideo", args: [] }));
    },
    vimeo: function (iframe, seconds) {
      postToFrame(iframe, JSON.stringify({ method: "setCurrentTime", value: seconds }));
      postToFrame(iframe, JSON.stringify({ method: "play" }));
    },
    cloudflare: cloudflareSeek,
    kinescope: kinescopeSeek,
  };

  // Неизвестный провайдер (data-player-kind="iframe") адаптера не имеет: API у него нет,
  // перемотать нечем. Молчаливый no-op запрещён (урок retro S4) — показываем подсказку.
  function runSeek(iframe, seconds, playerId) {
    var adapter = SEEK_ADAPTERS[iframe.getAttribute("data-player-kind")];
    if (!adapter) {
      showSeekUnavailable(iframe);
      return;
    }
    adapter(iframe, seconds, playerId);
  }

  // Готов ли плеер ПРИНЯТЬ команду: провайдер подтвердил ready ИЛИ доставка идёт не через
  // postMessage, а промисом SDK (kinescope) — там команда не теряется, ретраи не нужны.
  function apiReady(playerId, iframe) {
    if (PLAYER_API_READY[playerId]) return true;
    return iframe.getAttribute("data-player-kind") === "kinescope";
  }

  // РОВНО одна доставка на клик: PENDING_SEEK — и «что перемотать», и токен «ещё не доставлено».
  // ЕДИНСТВЕННАЯ точка отправки seek: токен снимается ДО отправки, поэтому любой сигнал, пришедший
  // следом (ready, «догоняющий» таймер), уже не может перемотать второй раз.
  function deliverSeek(playerId, iframe) {
    if (!(playerId in PENDING_SEEK)) return; // уже доставлено → второй раз НЕ перематываем
    var seconds = PENDING_SEEK[playerId];
    delete PENDING_SEEK[playerId];
    clearSeekTimers(playerId);
    runSeek(iframe, seconds, playerId);
  }

  // Последний рубеж: транспорт есть (iframe отдал load), а ready от провайдера так и не пришёл —
  // например, у YouTube-эмбеда нет enablejsapi, Vimeo старой версии не шлёт ready, приватный
  // контракт CF уплыл. Молчаливо терять клик нельзя (урок retro S4), поэтому доставляем вслепую,
  // но РОВНО ОДИН раз — через deliverSeek: он снимает токен, и опоздавший ready перемотку не
  // продублирует. Таймер живёт в SEEK_TIMERS → пришедший вовремя ready его снимает.
  function armLastResortSeek(playerId, iframe) {
    scheduleSeekTimer(playerId, SEEK_LAST_RESORT_MS, function () {
      deliverSeek(playerId, iframe);
    });
  }

  function seekPlayer(playerId, seconds) {
    var native = document.querySelector('video[data-player="' + playerId + '"]');
    if (native) {
      native.currentTime = seconds;
      var playing = native.play();
      if (playing && typeof playing.catch === "function") playing.catch(function () {});
      native.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    var iframe = document.querySelector('iframe[data-player="' + playerId + '"]');
    if (!iframe) return;
    iframe.scrollIntoView({ behavior: "smooth", block: "center" });

    // Неизвестный провайдер (data-player-kind="iframe") адаптера не имеет — перематывать нечем.
    // Говорим об этом сразу (молчаливый no-op запрещён, retro S4) и НЕ заводим ни токен, ни
    // таймеры: доставлять всё равно нечего, а мусор в реестре ломал бы инвариант «одна доставка».
    if (!SEEK_ADAPTERS[iframe.getAttribute("data-player-kind")]) {
      showSeekUnavailable(iframe);
      return;
    }

    clearSeekTimers(playerId); // новый клик отменяет отложенные эффекты предыдущего
    PENDING_SEEK[playerId] = seconds;

    // Плеер подтвердил готовность → команда уходит один раз, ретраи не нужны (не потеряется).
    if (apiReady(playerId, iframe)) {
      deliverSeek(playerId, iframe);
      return;
    }
    // Окно «клик до готовности API». Команду вслепую НЕ шлём: виджет провайдера принимает
    // postMessage раньше, чем отдаёт ready (YouTube исполняет {"event":"command"} независимо от
    // listening-хендшейка), поэтому слепая попытка могла быть исполнена, а пришедший следом ready
    // доставил бы тот же клик второй раз. Ждём ready-сигнал: YouTube отдаст onReady на хендшейк
    // (шлётся с ретраями из initLoadedPlayer), Vimeo/Cloudflare шлют ready сами. Если транспорта
    // ещё нет — рубеж взведёт markPlayerLoaded, когда iframe отдаст load.
    if (PLAYER_LOADED[playerId]) armLastResortSeek(playerId, iframe);
    // Cloudflare: ?startTime=-фолбэк — единственная страховка на случай, если iframeReady не
    // придёт вовсе, и она должна быть взведена уже сейчас (сам setProperty при этом НЕ шлём).
    if (iframe.getAttribute("data-player-kind") === "cloudflare") {
      armCloudflareFallback(iframe, seconds, playerId);
    }
  }

  // Iframe отдал load: транспорт есть → гасим таймер «Видео недоступно». Это НЕ значит, что API
  // плеера уже слушает команды, поэтому отложенный seek здесь НЕ доигрывается (см. markApiReady) —
  // но раз транспорт появился, взводим последний рубеж на случай, что ready так и не придёт.
  function markPlayerLoaded(playerId, iframe) {
    PLAYER_LOADED[playerId] = true;
    if (LOAD_TIMERS[playerId]) {
      clearTimeout(LOAD_TIMERS[playerId]);
      delete LOAD_TIMERS[playerId];
    }
    if (!PLAYER_API_READY[playerId] && playerId in PENDING_SEEK) armLastResortSeek(playerId, iframe);
  }

  // API провайдера подтвердило готовность: снимаем таймеры «слепого» окна и доигрываем
  // отложенный клик — ровно один раз.
  function markApiReady(playerId, iframe) {
    PLAYER_API_READY[playerId] = true;
    markPlayerLoaded(playerId, iframe);
    clearSeekTimers(playerId);
    deliverSeek(playerId, iframe);
  }

  function showVideoError(el) {
    var block = el.closest(".js-video-block");
    if (block) $(block).find(".js-video-error").removeClass("hidden");
  }

  // Перемотка по таймкоду не сработала (плеер провайдера не отдал API) — само видео при этом
  // играет, поэтому красный блок ошибки не показываем, только подсказку рядом с таймкодами.
  function showSeekUnavailable(el) {
    var block = el.closest(".js-video-block");
    if (block) $(block).find(".js-seek-unavailable").removeClass("hidden");
  }

  // Ready-сигналы провайдеров = подтверждение, что API плеера слушает команды (только ГАСЯТ
  // ошибку и флашат отложенный seek — ложных срабатываний дать не могут): Cloudflare —
  // iframeReady, YouTube — onReady (в ответ на наш listening-хендшейк), Vimeo — ready.
  window.addEventListener("message", function (e) {
    $("iframe[data-player]").each(function () {
      if (this.contentWindow !== e.source) return;
      var playerId = this.getAttribute("data-player");
      var data = e.data;
      if (data && typeof data === "object" && data.__privateUnstableMessageType === "iframeReady") {
        CF_READY[playerId] = true;
        markApiReady(playerId, this);
        return;
      }
      if (typeof data !== "string" || data.indexOf("{") !== 0) return;
      if (data.indexOf('"onReady"') > -1 || data.indexOf('"ready"') > -1) {
        markApiReady(playerId, this);
      }
    });
  });

  // Iframe загрузился: представляемся YouTube (onReady приходит только тому, кто послал
  // listening-хендшейк) и гасим таймер ошибки. Отложенный клик доигрывается НЕ здесь, а по
  // ready-сигналу провайдера (markApiReady) — load говорит лишь о транспорте.
  // Хендшейк шлём с ретраями: это НЕ seek-команда (повторный onReady идемпотентен —
  // deliverSeek отдаст клик один раз), а виджет YouTube подписывается на message чуть позже
  // события load у iframe: потерянный хендшейк = нет onReady = seek не доставлен (регресс S4).
  function initLoadedPlayer(iframe) {
    var playerId = iframe.getAttribute("data-player");
    if (PLAYER_LOADED[playerId]) return; // load + страховка window.load зовут нас дважды
    markPlayerLoaded(playerId, iframe);
    if (iframe.getAttribute("data-player-kind") !== "youtube") return;

    var handshake = JSON.stringify({ event: "listening", id: playerId, channel: "widget" });
    HANDSHAKE_RETRIES.forEach(function (delay) {
      setTimeout(function () {
        if (!PLAYER_API_READY[playerId]) postToFrame(iframe, handshake);
      }, delay);
    });
  }

  // Ready-gate + детекция «видео не загрузилось» (п.7): у каждого iframe-плеера таймер;
  // load снимает таймер и помечает плеер готовым. Плеер НЕ удаляем — может догрузиться.
  $("iframe[data-player]").each(function () {
    var iframe = this;
    var playerId = iframe.getAttribute("data-player");
    LOAD_TIMERS[playerId] = setTimeout(function () {
      showVideoError(iframe);
    }, VIDEO_LOAD_TIMEOUT_MS);

    $(iframe).on("load", function () {
      initLoadedPlayer(iframe);
    });

    // Прогреваем Kinescope заранее: к моменту клика по таймкоду плеер уже поднят.
    if (iframe.getAttribute("data-player-kind") === "kinescope") kinescopePlayer(iframe, playerId);
  });

  // Страховка от ЛОЖНОГО «Видео недоступно»: пак подключён с defer, поэтому у закэшированного
  // (или просто быстрого) embed'а событие `load` могло случиться ДО того, как обработчик выше
  // навесился, — таймер тогда никто не гасит и через VIDEO_LOAD_TIMEOUT_MS красный блок вылезает
  // под исправно играющим видео. window.load наступает только ПОСЛЕ загрузки всех iframe → как
  // сигнал готовности ложных срабатываний дать не может, только снимает их. Если window.load уже
  // прошёл (bfcache/поздняя инициализация) — флашим сразу.
  function flushLoadedPlayers() {
    $("iframe[data-player]").each(function () {
      initLoadedPlayer(this);
    });
  }

  if (document.readyState === "complete") flushLoadedPlayers();
  else $(window).on("load", flushLoadedPlayers);

  $(document).on("click", ".js-timecode", function () {
    seekPlayer($(this).data("player"), parseFloat($(this).data("seconds")));
  });

  // Скорость воспроизведения нативного плеера (кросс-браузерная гарантия критерия «скорость»).
  $(document).on("change", ".js-playback-rate", function () {
    var video = document.querySelector('video[data-player="' + $(this).data("player") + '"]');
    if (video) video.playbackRate = parseFloat($(this).val());
  });

  // Сломанный источник нативного видео → показать сообщение, страница не ломается (S15).
  // Событие error у media не всплывает → делегируем через capture-фазу.
  document.addEventListener(
    "error",
    function (e) {
      var el = e.target;
      if (!el || el.tagName !== "VIDEO") return;
      showVideoError(el);
    },
    true
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // LMS-админка (S5, п.10): гамбургер сворачивает/разворачивает левый сайдбар.
  // Состояние переживает перезагрузку (localStorage); на узком экране сайдбар — оверлей
  // с затемнением, по умолчанию свёрнут.
  // ─────────────────────────────────────────────────────────────────────────────
  var SIDEBAR_KEY = "lms:admin:sidebar-collapsed";
  var SIDEBAR_NARROW_PX = 768; // Tailwind md — ниже него сайдбар живёт оверлеем с затемнением
  var $sidebar = $(".js-lms-sidebar");

  if ($sidebar.length) {
    var $backdrop = $(".js-lms-sidebar-backdrop");
    var $toggle = $(".js-lms-sidebar-toggle");

    var narrowScreen = function () {
      return window.innerWidth < SIDEBAR_NARROW_PX;
    };

    var applySidebar = function (collapsed) {
      $sidebar.toggleClass("hidden", collapsed);
      $backdrop.toggleClass("hidden", collapsed);
      $toggle.attr("aria-expanded", collapsed ? "false" : "true");
    };

    // На узком экране сайдбар — модальный оверлей: он ВСЕГДА стартует свёрнутым и его состояние
    // НЕ запоминается. Иначе основной мобильный сценарий («открыл меню → ткнул раздел») оставлял
    // бы в localStorage "0", и на каждой следующей странице меню снова висело бы оверлеем поверх
    // контента, требуя закрывать его руками. localStorage — только про широкий экран, где сайдбар
    // сидит в потоке и «оставить свёрнутым» — осмысленное пользовательское предпочтение.
    applySidebar(narrowScreen() ? true : localStorage.getItem(SIDEBAR_KEY) === "1");

    $toggle.on("click", function () {
      var collapsed = !$sidebar.hasClass("hidden");
      applySidebar(collapsed);
      if (!narrowScreen()) localStorage.setItem(SIDEBAR_KEY, collapsed ? "1" : "0");
    });

    // Клик по затемнению = закрыть оверлей (состояние узкого экрана не сохраняем — см. выше).
    $backdrop.on("click", function () {
      applySidebar(true);
    });
  }
});
